import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useStaffCard = (id, enabled = true) => {
  return useQuery({
    queryKey: ["staffCardState", id],
    enabled: enabled,
    queryFn: async () =>
      callApi({
        path: "staffCard",
        command: "",
        data: JSON.stringify({
          data: { filter: { f_staffId: id } },
        }),
      }),
  });
};

// const filter = { filter: { f_staffId: null } };
//   filter.filter.f_staffId = staffId;
//   const data = useApiDataFetch({
//     path: "staffCard",
//     command: "",
//     data: JSON.stringify({ data: filter }),
//   });
